export const latency = {
  // NOTE: How long to wait when a user types to avoid flooding our servers with
  // requests.
  typing: 500,
}
